<script setup>
import '@mogelijk-technologies/styles/src/index.css';
import '@mogelijk-technologies/ui-library/dist/style.css';
import '@assets/css/style.css';

import { GET_PACKAGE, GET_LANGUAGES } from '@graphql/queries/language';
import { CombinedError } from '@urql/vue';
import { useUrqlStore } from '@stores/useUrqlStore';
import { useI18n } from 'vue-i18n';

const { gqlClient } = toRefs(useUrqlStore());
const { setLocaleMessage } = useI18n();

const pages = ref([]);
const languages = ref(undefined);

const createLocaleMessage = languageId => {
  const message = {};

  for (const page of pages.value) {
    message[page.url] = {};

    for (const element of page.elements) {
      const content = element.contents.find(translation => translation.cms_language_id === languageId)?.content;

      message[page.url][element.element] = content?.replaceAll('@', '&#64;');
    }
  }

  return message;
};

const fetchLanguages = async () => {
  return gqlClient.value
    ?.query(GET_LANGUAGES, {}, {
      requestPolicy: 'cache-and-network',
    })
    .toPromise()
    .then(result => {
      if (result.data) {
        languages.value = result.data.cmsLanguages;
      }

      if (result.error) {
        throw new CombinedError(result.error);
      }
    });
};

const fetchPackageContent = async () => {
  return gqlClient.value
    ?.query(GET_PACKAGE, { id: import.meta.env.VITE_CMS_PACKAGE_ID }, {
      requestPolicy: 'cache-and-network',
    })
    .toPromise()
    .then(result => {
      if (result.data?.cmsPackage && languages.value) {
        pages.value = result.data.cmsPackage.pages;

        for (const language of languages.value) {
          const content = createLocaleMessage(language.id);

          setLocaleMessage(language.code, content);
        }

        return result.data.cmsPackage;
      }

      return undefined;
    });
};

onMounted(async () => {
  await fetchLanguages();
  fetchPackageContent();
});
</script>

<template>
  <NuxtPage />
</template>
